import React, { useState, useEffect } from "react";
import {
  //  Avatar,
  Box,
  Typography,
} from "@mui/material";
import { api } from "../../api/api";
import { Coupan } from "../../api/urls";
// import LOGO from "../../Assests/photo.jpg";
import Image from "../../components/Image";
import Loading from "../../components/Loading";
// import { useSelector } from "react-redux";
import placeholderImg from "../../Assests/placeholder.jpg"
import moment from "moment";

const CouponCard = ({ coupon }) => {
  return (
    <Box
      sx={{
        width: { xs: "100%", sm: 350 },
        height: 120,
        backgroundColor: "#F0F0F0",
        position: "relative",
        borderRadius: 3,
        overflow: "hidden",
        textAlign: "center",
        p: 3,
        display: "flex",
        gap: 1,
        alignItems: "center",
        fontFamily: "'Inter', sans-serif",
        fontSize: "16px",
        "&::before, &::after": {
          content: '""',
          position: "absolute",
          width: 30,
          height: 30,
          borderRadius: "50%",
          backgroundColor: "#fff",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 1,
        },
        "&::before": {
          left: -15,
        },
        "&::after": {
          right: -15,
        },
      }}
    >
      {
        <Image
          src={coupon?.coupon_image || placeholderImg}
          alt="Coupon"
          style={{
            width: 80,
            height: 80,
            objectFit: "contain",
            borderRadius: "50%",
            flexShrink: 0,
          }}
        />
      }

      <Box
        sx={{
          height: "100%",
          borderLeft: "3px dashed #bbb",
        }}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 0.5,
          pl: 2,
          height: "100%",
          marginRight: "20px", // <-- added marginRight here
        }}
      >
        {/* <Typography sx={{ fontSize: "20px", fontWeight: 700, lineHeight: 1 }}>
          {coupon?.discount_upto || "50"}% OFF
        </Typography>
        <Typography sx={{ fontSize: "15px", fontWeight: 500, lineHeight: 1.2 }}>
          {coupon?.coupon_request_status || "U.S. POLO ASSN."}
        </Typography>
        <Typography sx={{ fontSize: "12px", color: "#999", marginTop: "10px" }}>
          Valid until {coupon?.validity_date || "01 October 2024"}
        </Typography> */}
        <Typography sx={{ fontSize: "25px", fontWeight: 700 }}>
          {coupon.discount_upto}% Off
        </Typography>
        <Typography sx={{ fontSize: "20px", fontWeight: 500 }}>
          {coupon.promocode}
        </Typography>

        {/* <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
  Code: {coupon.code}
</Typography> */}

        {/* <Typography sx={{ fontSize: "12px", color: "#999" }}>
  Name: {coupon.expiry}
</Typography> */}
        <Typography sx={{ fontSize: "12px", color: "#555" }}>
          {/* Valid until: {moment(coupon.expiry).format("DD|MM|YYYY -HH:mm")} */}
          Valid until:{" "}
          {moment(coupon.expiry).format("DD MMMM YYYY").toLowerCase()}
        </Typography>
      </Box>
    </Box>
  );
};

const DiscountCoupon = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(Coupan);
        setData(response.data);
      } catch (error) {
        setError("Error fetching coupons");
        console.error("Error:", error);
      }
    };

    fetchData();
  }, []);

  if (error)
    return (
      <Typography color="error" sx={{ fontSize: "16px" }}>
        {error}
      </Typography>
    );

  if (!data) return <Loading />;

  return (
    <Box sx={{ width: "100%", minHeight: "100vh", p: 2 }}>
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        alignItems="center"
        justifyContent={{ xs: "center", sm: "start" }}
        gap={2}
        flexWrap="wrap"
      >
        {data.map((coupon, index) => (
          <CouponCard key={index} coupon={coupon} />
        ))}
      </Box>
    </Box>
  );
};

export default DiscountCoupon;
